// @flow
import { OficinasActionTypes } from './constants';

type OficinasAction = { type: string, payload: {} | string };

// common success
export const oficinasApiResponseSuccess = (actionType: string, data: any): OficinasAction => ({
    type: OficinasActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const oficinasApiResponseError = (actionType: string, error: string): OficinasAction => ({
    type: OficinasActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const listOficinas = (params: any): OficinasAction => ({
    type: OficinasActionTypes.LIST_OFICINAS,
    payload: params,
});
export const getOficina = (id: string): OficinasAction => ({
    type: OficinasActionTypes.GET_OFICINA,
    payload: { id },
});

export const addOficina = (oficina:any):OficinasAction=>({
    type:OficinasActionTypes.ADD_OFICINA,
    payload:oficina
})
export const updateOficina = (oficina:any):OficinasAction=>({
    type:OficinasActionTypes.UPDATE_OFICINA,
    payload:oficina
})
export const deleteOficina = (id:string):OficinasAction=>({
    type:OficinasActionTypes.DELETE_OFICINA,
    payload:{id}
})

export const resetOficinas = (): OficinasAction => ({
    type: OficinasActionTypes.RESET,
    payload: {},
});

